// Universities & Schools section — 8 languages
export const universitiesI18n = {
  ru: {
    eyebrow: 'Universities & Schools',
    title: 'Вузы и школы, где уже учатся наши клиенты',
    subtitle: '200+ учебных заведений в 15 странах мира',
    allTab: 'Все',
    schoolBadge: 'School',
    showAll: (n) => `Показать все (${n}) →`,
    collapse: 'Свернуть ↑',
    cta: 'Подобрать вуз или школу под мои критерии'
  },
  uk: {
    eyebrow: 'Universities & Schools',
    title: 'Виші та школи, де вже навчаються наші клієнти',
    subtitle: '200+ навчальних закладів у 15 країнах світу',
    allTab: 'Усі',
    schoolBadge: 'School',
    showAll: (n) => `Показати всі (${n}) →`,
    collapse: 'Згорнути ↑',
    cta: 'Підібрати виш або школу за моїми критеріями'
  },
  en: {
    eyebrow: 'Universities & Schools',
    title: 'Universities and schools where our clients already study',
    subtitle: '200+ institutions across 15 countries',
    allTab: 'All',
    schoolBadge: 'School',
    showAll: (n) => `Show all (${n}) →`,
    collapse: 'Collapse ↑',
    cta: 'Find a university or school for me'
  },
  ar: {
    eyebrow: 'الجامعات والمدارس',
    title: 'الجامعات والمدارس التي يدرس فيها عملاؤنا',
    subtitle: 'أكثر من 200 مؤسسة تعليمية في 15 دولة',
    allTab: 'الكل',
    schoolBadge: 'مدرسة',
    showAll: (n) => `عرض الكل (${n}) ←`,
    collapse: 'طي ↑',
    cta: 'اختر لي جامعة أو مدرسة'
  },
  it: {
    eyebrow: 'Università e Scuole',
    title: 'Università e scuole dove studiano già i nostri clienti',
    subtitle: '200+ istituti in 15 paesi nel mondo',
    allTab: 'Tutti',
    schoolBadge: 'Scuola',
    showAll: (n) => `Mostra tutti (${n}) →`,
    collapse: 'Comprimi ↑',
    cta: 'Trova università o scuola per me'
  },
  zh: {
    eyebrow: '大学与学校',
    title: '我们客户正在就读的大学与学校',
    subtitle: '15 个国家、200+ 所院校',
    allTab: '全部',
    schoolBadge: '学校',
    showAll: (n) => `查看全部 (${n}) →`,
    collapse: '收起 ↑',
    cta: '为我推荐大学或学校'
  },
  es: {
    eyebrow: 'Universidades y Escuelas',
    title: 'Universidades y escuelas donde ya estudian nuestros clientes',
    subtitle: '200+ instituciones en 15 países',
    allTab: 'Todos',
    schoolBadge: 'Escuela',
    showAll: (n) => `Ver todos (${n}) →`,
    collapse: 'Contraer ↑',
    cta: 'Encuentra una universidad o escuela para mí'
  },
  pl: {
    eyebrow: 'Uczelnie i Szkoły',
    title: 'Uczelnie i szkoły, na których już studiują nasi klienci',
    subtitle: '200+ instytucji w 15 krajach świata',
    allTab: 'Wszystkie',
    schoolBadge: 'Szkoła',
    showAll: (n) => `Pokaż wszystkie (${n}) →`,
    collapse: 'Zwiń ↑',
    cta: 'Dobierz uczelnię lub szkołę dla mnie'
  }
};
